// data format: response.list = [{},{}...]
export function flattenResponse(response) {
        let flattendResponse = [];
        response.list.forEach((row, index) => { 
            let flat = {}
            Object.keys(row).forEach((key) => {
            // console.log(typeof obj[key])
            //if string
            if (typeof row[key] !== 'object' || row[key].length === 0){
                flat = {...flat, [key]: row[key]}
            }
            if (Array.isArray(row[key])){
                row[key].forEach((el, index) => {
                    if(typeof el !== 'object'){
                        flat = {...flat, [key + "_" + index]: el};
                    } else {
                       if(Array.isArray(el)){
                           el.map((i, index2) => {
                                flat = {...flat, [key + "_" + index + "_" + index2 + "_"]: i}
                           })
                       } if(!Array.isArray(el)){
                           Object.keys(el).forEach((key2) => {
                               if(key2 !== 'organization'){
                                Object.keys(row[key][index][key2]).forEach((key3) => {
                                    // if(typeof obj[key][index][key2][key3] !== 'object') {
                                        flat = {...flat, [key + "_" + index + "_" + key2 + "_" + key3]: row[key][index][key2][key3]}
                                
                                    
                                    })
                                } else{
                                   if(row[key][index][key2].name === 'sha'){Object.keys(row[key][index][key2]).forEach((key3) => {
                                    // if(typeof obj[key][index][key2][key3] !== 'object') {
                                        flat = {...flat, [key2 + "_" + key3]: row[key][index][key2][key3]}
                                
                                    
                                    })
                                   }
                                   if(row[key][index][key2].name === 'regenagonline'){Object.keys(row[key][index][key2]).forEach((key3) => {
                                    // if(typeof obj[key][index][key2][key3] !== 'object') {
                                        flat = {...flat, [key2 + "_" + key3]: row[key][index][key2][key3]}
                                
                                    
                                    })
                                   }
                                }
                           })
                       }     
                    }
                })
            } if (typeof row[key] === 'object' && !Array.isArray(row[key])) {
                Object.keys(row[key]).forEach((key2) => {
                    if(typeof row[key][key2] !== 'object'){
                        flat = {...flat, [key + "_" + key2]: row[key][key2]}
                    } else {
                        
                        if(row[key][key2] !== null && row[key][key2] !== undefined){
                        Object.keys(row[key][key2]).forEach((key3) => {
                            flat = {...flat, [key + "_" + key2 + "_" + key3]: row[key][key2][key3]}
                        })} else {
                            flat = {...flat, [key + "_" + key2]: ""}
                        }
                    }
                })
            }
            //if object
                //see if array or obj
                //otherwise push eacht to flat obj
        })
        flattendResponse.push(flat)
    })
    return flattendResponse;
}
